import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "top-search"
};
import { ref, reactive, watch, onMounted } from 'vue';
/** 接口 */
import { getAllOptions } from '@/api/index-fu.js';
export default {
  __name: 'topSearch',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['searchData', 'update:modelValue'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /** 组合式api */
    var props = __props;
    var emit = __emit;
    /** 初始化相关 */
    var search = reactive({
      classType: null,
      // 班级类型
      classId: null,
      // 班级ID
      className: '',
      // 班级名称
      subjectDictItemCode: null,
      // 学科code
      subjectDictItemName: '' // 学科名称
    });
    var classTypeOptions = ref([]); // 班级类型下拉
    var classOptions = ref([]); // 班级下拉
    var subjectOptions = ref([]); // 学科下拉

    var allOptionsData = ref([]); // 班级类型、班级、学科下拉数据
    var getClassTypeOptions = function getClassTypeOptions(data) {
      classTypeOptions.value = _toConsumableArray(data);
      if (classTypeOptions.value.length) {
        search.classType = classTypeOptions.value[0].classType;
        getClassOptions(data); // 获取班级类型下拉 + 赋值
      }
    };
    var getClassOptions = function getClassOptions(allOptionsData, classId) {
      var findData = allOptionsData.find(function (i) {
        return i.classType === search.classType;
      });
      var findClass;
      if (findData) {
        classOptions.value = findData.classListVOS;
        if (classId) {
          findClass = classOptions.value.find(function (i) {
            return i.classId === classId;
          });
          search.classId = findClass.classId;
          search.className = findClass.className;
        } else {
          search.classId = classOptions.value[0].classId;
          search.className = classOptions.value[0].className;
        }
      } else {
        classOptions.value = [];
        search.classId = null;
        search.className = '';
      }
      if (classId) {
        getSubjectOptions(findClass); // 获取学科下拉 + 赋值
      } else {
        getSubjectOptions(findData.classListVOS[0]); // 获取学科下拉 + 赋值
      }
    };
    var getSubjectOptions = function getSubjectOptions(findData) {
      if (findData) {
        subjectOptions.value = findData.teachSubjectVOList;
        search.subjectDictItemCode = subjectOptions.value[0].subjectDictItemCode;
        search.subjectDictItemName = subjectOptions.value[0].subjectDictItemName;
      } else {
        subjectOptions.value = [];
        search.subjectDictItemCode = null;
        search.subjectDictItemName = '';
      }
    };

    /** 初始化数据 */
    var initData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _res$data, code, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return getAllOptions(1);
            case 1:
              res = _context.v;
              _res$data = res.data, code = _res$data.code, data = _res$data.data;
              if (code === 0) {
                allOptionsData.value = data || [];
                console.log('105----调用接口获取到的allOptionsData.value', allOptionsData.value);
                getClassTypeOptions(allOptionsData.value); // 获取班级类型下拉 + 赋值
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log('error', _t);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      return function initData() {
        return _ref2.apply(this, arguments);
      };
    }();
    /** 监听 */
    // 监听学科是否为行政分组，创建小组按钮显隐
    watch(search, function (nval) {
      if (nval.classType === 0) {
        if (Number(nval.subjectDictItemCode) === -1) {
          emit('update:modelValue', true);
        } else {
          emit('update:modelValue', false);
        }
      } else {
        var findData = classOptions.value.find(function (i) {
          return i.classId === search.classId;
        });
        if (findData.leaderFlag) emit('update:modelValue', true);
      }
    });
    watch(function () {
      return [search.classId, search.subjectDictItemCode];
    }, function (nval) {
      emit('searchData', search);
    });

    /** 事件相关 */
    /**
     * 更改学科_学科名同步更新
     */
    var changeSubject = function changeSubject() {
      var findData = subjectOptions.value.find(function (i) {
        return i.subjectDictItemCode === search.subjectDictItemCode;
      });
      search.subjectDictItemName = findData.subjectDictItemName;
    };
    onMounted(function () {
      initData(); // 获取班级类型、班级、学科下拉
    });
    return function (_ctx, _cache) {
      var _component_t_select = _resolveComponent("t-select");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_t_select, {
        modelValue: search.classType,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return search.classType = $event;
        }),
        options: classTypeOptions.value,
        keys: {
          label: 'className',
          value: 'classType'
        },
        placeholder: "请选择班级类型",
        class: "right-32",
        onChange: _cache[1] || (_cache[1] = function ($event) {
          return getClassOptions(allOptionsData.value);
        })
      }, null, 8, ["modelValue", "options"]), _createVNode(_component_t_select, {
        modelValue: search.classId,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return search.classId = $event;
        }),
        options: classOptions.value,
        keys: {
          label: 'className',
          value: 'classId'
        },
        placeholder: "请选择班级",
        class: "right-32",
        onChange: _cache[3] || (_cache[3] = function ($event) {
          return getClassOptions(allOptionsData.value, search.classId);
        })
      }, null, 8, ["modelValue", "options"]), _createVNode(_component_t_select, {
        modelValue: search.subjectDictItemCode,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return search.subjectDictItemCode = $event;
        }),
        options: subjectOptions.value,
        keys: {
          label: 'subjectDictItemName',
          value: 'subjectDictItemCode'
        },
        placeholder: "请选择学科",
        class: "right-32",
        onChange: changeSubject
      }, null, 8, ["modelValue", "options"])]);
    };
  }
};